<div class="content">
    <div class="card-data">
        <div class="card-header">
            <span class="card-title">{{title}}</span>
            <nz-input-group *ngIf="showSearch" class="search-field" [nzPrefix]="searchIcon">
                <input nz-input (keyup)="updateFilter($event)" placeholder="Filtro" />
            </nz-input-group>
            <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
        </div>
        <div class="progress-line" [class.progress-line-active]="showProgress"></div>
        <div class="card-content">
            <div class="header-line" [style.grid-template-columns]="gridTemplate()">
                <div class="header" *ngFor="let column of cols" [style.grid-column]="'span ' + column.colspan" nz-tooltip [nzTooltipTitle]="column.name">{{column.name}}</div>
            </div>
            <div class="variation-grid" #grid>
                <div *ngFor="let data of localArray" class="lines" (click)="selectLine(data)" [style.grid-template-columns]="gridTemplate()">
                    <div *ngFor="let column of cols" class="cell" [style.grid-column]="'span ' + column.colspan">
                        <label *ngIf="column.type=='select'" nz-checkbox [(ngModel)]="data.selected" (click)="$event.stopPropagation()"></label>

                        <div *ngIf="column.type=='text'" class="column-data" nz-tooltip [nzTooltipTitle]="column.showToolTip ? getData(data,column.path) : ''">
                            <div class="data-text">{{getData(data,column.path)}}</div>
                        </div>

                        <div *ngIf="column.type=='object'" class="column-data" nz-tooltip [nzTooltipTitle]="column.showToolTip ? getDataObject(data,column.path) : ''">
                            <div [innerHtml]="getDataObject(data,column.path)" class="data-object"></div>
                        </div>

                        <button *ngIf="column.type=='edit'" nz-button nzType="text" nzShape="circle" nzSize="small" (click)="editarItem(data);$event.stopPropagation()">
                            <nz-icon nzType="edit"></nz-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="action-image-buttons">
            <actions-buttons [buttonList]="buttonList" [data]="{}"></actions-buttons>
        </div>
    </div>
</div>
